import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// All projects with type labels for hover display
// Featured order on first entry: Monox+, Talks, Worx, Balsan, IMTM, Narwal, Flormar — then the rest
const PROJECTS = [
  { id: 17, title: "Monox+",           slug: "monox",                  type: "Event Design", video: "https://customer-assets.emergentagent.com/job_8f19abab-0179-4d97-b1c9-811ecc7078a8/artifacts/vju7njin_%D7%90%D7%9C_%D7%AA%D7%99%D7%92%D7%A2_%D7%91%D7%98%D7%A7%D7%A1%D7%98%D7%99%D7%9D_%D7%A8%D7%A7_%D7%AA%D7%A2%D7%A9%D7%94_%D7%90%D7%A0%D7%99%D7%9E%D7%A6%D7%99.mp4", image: "https://customer-assets.emergentagent.com/job_8f19abab-0179-4d97-b1c9-811ecc7078a8/artifacts/oiff8ruu_monox_marchgrid_TSK-2777_po4_2.png" },
  { id: 18, title: "Talks",            slug: "talks",                  type: "Branding", image: "https://customer-assets.emergentagent.com/job_8f19abab-0179-4d97-b1c9-811ecc7078a8/artifacts/ketftyx5_Instagram%20post%20-%201.png" },
  { id: 4,  title: "Worx Design",      slug: "worx",                   type: "Social",   image: "https://customer-assets.emergentagent.com/job_design-works-16/artifacts/k3z6l2t9_1_0.png" },
  { id: 2,  title: "Balsan",           slug: "balsan",                 type: "Social",   image: "https://customer-assets.emergentagent.com/job_web-portfolio-306/artifacts/6a2j44j8_1.png" },
  { id: 1,  title: "IMTM 2026",        slug: "imtm",                   type: "Social",   image: "https://customer-assets.emergentagent.com/job_artful-avoidance/artifacts/ivphz1y8_5.png" },
  { id: 15, title: "Narwal",           slug: "narwal",                 type: "Campaign", image: "https://customer-assets.emergentagent.com/job_purple-portfolio-16/artifacts/siyzbibi_11.png" },
  { id: 11, title: "Flormar",          slug: "flormar",                type: "Campaign", image: "https://customer-assets.emergentagent.com/job_purple-portfolio-16/artifacts/mi2ua7g4_Instagram%20post%20-%2030.png" },
  { id: 3,  title: "Spring Catalog",   slug: "polygon",                type: "Creative", image: "https://customer-assets.emergentagent.com/job_visual-works-31/artifacts/i505suaz_poster.png", objectPosition: "top center" },
  { id: 5,  title: "Deja Blue",        slug: "dejablue",               type: "Social",   image: "https://customer-assets.emergentagent.com/job_purple-portfolio-16/artifacts/t08rseo7_DejaBlue_febgrid_2619_6.png" },
  { id: 6,  title: "Cérémonie Tea",    slug: "ceremonie",              type: "Social",   image: "https://customer-assets.emergentagent.com/job_design-works-16/artifacts/c1mw3kbr_ceremonie_decgrid_2391_2.png" },
  { id: 7,  title: "True Story",       slug: "truestory-fullfunnel",   type: "Campaign", image: "https://customer-assets.emergentagent.com/job_design-works-16/artifacts/qtxkg3bb_1.png" },
  { id: 8,  title: "Bob",              slug: "bob",                    type: "Branding", image: "https://customer-assets.emergentagent.com/job_visual-works-31/artifacts/0dzm68dy_ChatGPT%20Image%20Mar%207%2C%202026%2C%2004_18_37%20PM.png", objectPosition: "center 70%" },
  { id: 9,  title: "Moments",          slug: "moments",                type: "Branding", image: "https://customer-assets.emergentagent.com/job_minimal-portfolio-87/artifacts/65y8q2wi_p%2Chjv.png" },
  { id: 10, title: "Goodlife",         slug: "goodlife-ab",            type: "Campaign", image: "https://customer-assets.emergentagent.com/job_design-works-16/artifacts/l2zz6cai_1.png" },
  { id: 12, title: "The Plane",        slug: "theplane",               type: "Branding", image: "https://customer-assets.emergentagent.com/job_design-works-16/artifacts/e5hoojyb_extrior2.png" },
  { id: 13, title: "Posters",          slug: "poster",                 type: "Print",    image: "https://customer-assets.emergentagent.com/job_minimal-portfolio-87/artifacts/dtjvscs2_web.png" },
  { id: 14, title: "Valhalla",         slug: "valhalla",               type: "Game",     image: "https://customer-assets.emergentagent.com/job_purple-portfolio-16/artifacts/k88ly7ho_%D7%A4%D7%AA%D7%99%D7%97%D7%95%D7%A9.png" },
  { id: 16, title: "Smoovee",          slug: "smoovee",                type: "Social",   image: "/images/smoovee/cover.png" },
];

// Grid layout - 7 cols × 4 rows = 28 cells (18 unique + 10 strategic repeats, NEVER monox/featured)
// gridWidth (7*304=2128px) and gridHeight (4*304=1216px) both exceed typical viewport
// so the monox tile (and any single project) appears at most ONCE per visible screen.
const GRID_COLS = 7;
const GRID_ROWS = 4;
const CELL_SIZE = 280;
const GAP = 24; // Increased gap for white background
const COPIES = 4; // How many times the grid repeats

// Custom layout map: 28 grid positions → project indices in PROJECTS array.
// Row 0 (featured, first entry view): monox, talks, worx, balsan, imtm, narwal, flormar
// Repeats sit in the lower rows, NON-FEATURED projects only, never adjacent to their originals.
const POSITION_MAP = [
  // Row 0 (featured): monox(0), talks(1), worx(2), balsan(3), imtm(4), narwal(5), flormar(6)
  0, 1, 2, 3, 4, 5, 6,
  // Row 1: polygon(7), deja(8), ceremonie(9), truestory(10), bob(11), moments(12), goodlife(13)
  7, 8, 9, 10, 11, 12, 13,
  // Row 2: theplane(14), posters(15), valhalla(16), smoovee(17), polygon*, deja*, ceremonie*
  14, 15, 16, 17, 7, 8, 9,
  // Row 3 (all repeats of NON-featured): truestory*, bob*, moments*, goodlife*, theplane*, posters*, valhalla*
  10, 11, 12, 13, 14, 15, 16,
];

// Layout maps project indices to grid positions - no project adjacent to itself
const getProjectIndex = (row, col) => {
  const cellIndex = row * GRID_COLS + col;
  return POSITION_MAP[cellIndex % POSITION_MAP.length];
};

const pageTransition = {
  initial: { opacity: 0, y: 20 },
  animate: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.5, ease: [0.25, 0.46, 0.45, 0.94] }
  },
  exit: { 
    opacity: 0,
    transition: { duration: 0.3 }
  },
};

export default function Works() {
  const containerRef = useRef();
  const gridRef = useRef();
  const panX = useRef(0);
  const panY = useRef(0);
  const velX = useRef(0);
  const velY = useRef(0);
  const isDragging = useRef(false);
  const lastPX = useRef(0);
  const lastPY = useRef(0);
  const animRef = useRef();
  const [dragging, setDragging] = useState(false);
  const navigate = useNavigate();
  
  const hasDragged = useRef(false);
  const clickedProject = useRef(null);

  // Calculate grid dimensions - include GAP after last item for seamless tiling
  const gridWidth = GRID_COLS * (CELL_SIZE + GAP);
  const gridHeight = GRID_ROWS * (CELL_SIZE + GAP);

  useEffect(() => {
    const loop = () => {
      animRef.current = requestAnimationFrame(loop);

      if (!isDragging.current) {
        velX.current *= 0.94;
        velY.current *= 0.94;
        panX.current += velX.current;
        panY.current += velY.current;
      }

      // Infinite wrap
      const wrapX = gridWidth;
      const wrapY = gridHeight;
      if (panX.current >= wrapX) panX.current -= wrapX;
      if (panX.current <= -wrapX) panX.current += wrapX;
      if (panY.current >= wrapY) panY.current -= wrapY;
      if (panY.current <= -wrapY) panY.current += wrapY;

      if (gridRef.current) {
        gridRef.current.style.transform = `translate3d(${panX.current - wrapX}px,${panY.current - wrapY}px,0)`;
      }
    };
    loop();

    const onPointerDown = (e) => {
      isDragging.current = true;
      setDragging(true);
      lastPX.current = e.clientX;
      lastPY.current = e.clientY;
      velX.current = 0;
      velY.current = 0;
      hasDragged.current = false;
      clickedProject.current = null;
      
      const target = e.target.closest('.bento-cell');
      if (target) {
        clickedProject.current = target.dataset.projectSlug;
      }
    };

    const onPointerMove = (e) => {
      if (!isDragging.current) return;
      const dx = e.clientX - lastPX.current;
      const dy = e.clientY - lastPY.current;
      
      if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
        hasDragged.current = true;
      }
      
      panX.current += dx;
      panY.current += dy;
      velX.current = dx;
      velY.current = dy;
      lastPX.current = e.clientX;
      lastPY.current = e.clientY;
    };

    const onPointerUp = () => {
      isDragging.current = false;
      setDragging(false);
      
      if (!hasDragged.current && clickedProject.current) {
        navigate(`/project/${clickedProject.current}`);
      }
    };

    const el = containerRef.current;
    if (!el) return;
    
    el.addEventListener("pointerdown", onPointerDown);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup", onPointerUp);

    return () => {
      cancelAnimationFrame(animRef.current);
      el.removeEventListener("pointerdown", onPointerDown);
      window.removeEventListener("pointermove", onPointerMove);
      window.removeEventListener("pointerup", onPointerUp);
    };
  }, [navigate, gridWidth, gridHeight]);

  // Build cells - uniform 1x1 grid, no project touches itself
  const cells = [];
  for (let copyY = 0; copyY < COPIES; copyY++) {
    for (let copyX = 0; copyX < COPIES; copyX++) {
      for (let row = 0; row < GRID_ROWS; row++) {
        for (let col = 0; col < GRID_COLS; col++) {
          const projIndex = getProjectIndex(row, col);
          const proj = PROJECTS[projIndex];
          const x = copyX * gridWidth + col * (CELL_SIZE + GAP);
          const y = copyY * gridHeight + row * (CELL_SIZE + GAP);
          
          cells.push({
            key: `${copyX}-${copyY}-${row}-${col}`,
            proj,
            x, y,
            w: CELL_SIZE,
            h: CELL_SIZE,
          });
        }
      }
    }
  }

  return (
    <motion.div
      data-testid="works-page"
      variants={pageTransition}
      initial="initial"
      animate="animate"
      exit="exit"
      style={{ width: "100vw", height: "100vh", overflow: "hidden", position: "relative", background: "#FFFFFF" }}
    >
      <style>{`
        .bento-cell { 
          position: absolute; 
          overflow: hidden; 
          border-radius: 12px;
        }
        .bento-cell .overlay {
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        .bento-cell:hover .overlay { opacity: 1; }
        .is-dragging .bento-cell .overlay { opacity: 0 !important; }
        .bento-cell img { transition: transform 0.6s ease; }
        .bento-cell:hover img { transform: scale(1.05); }
        .is-dragging .bento-cell img { transform: none !important; }
        
        @media (max-width: 768px) {
          .bento-cell {
            display: none !important;
          }
        }
      `}</style>

      <div
        ref={containerRef}
        data-testid="works-grid-container"
        className={`works-grid-area ${dragging ? "is-dragging" : ""}`}
        style={{
          position: "absolute",
          inset: 0,
          userSelect: "none",
          touchAction: "none",
          overflow: "hidden",
        }}
      >
        <div
          ref={gridRef}
          style={{
            position: "relative",
            width: `${COPIES * gridWidth}px`,
            height: `${COPIES * gridHeight}px`,
            willChange: "transform",
          }}
        >
          {cells.map(({ key, proj, x, y, w, h }) => (
            <div
              key={key}
              className="bento-cell"
              data-project-slug={proj.slug}
              data-testid={`project-cell-${proj.slug}`}
              style={{
                left: `${x}px`,
                top: `${y}px`,
                width: `${w}px`,
                height: `${h}px`,
              }}
            >
              <img
                src={proj.image}
                alt={proj.title}
                draggable={false}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: proj.objectPosition || "center",
                  display: "block",
                  pointerEvents: "none",
                }}
              />
              {proj.video && (
                <video
                  src={proj.video}
                  autoPlay
                  loop
                  muted
                  playsInline
                  preload="metadata"
                  style={{
                    position: "absolute",
                    inset: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    objectPosition: proj.objectPosition || "center",
                    display: "block",
                    pointerEvents: "none",
                  }}
                />
              )}
              <div
                className="overlay"
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "#8B8BF5",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "6px",
                }}
              >
                <span
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 700,
                    fontSize: "0.95rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    color: "#FFFFFF",
                    textShadow: "0 2px 8px rgba(0,0,0,0.3)",
                  }}
                >
                  {proj.title}
                </span>
                <span
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontWeight: 400,
                    fontSize: "0.65rem",
                    letterSpacing: "0.1em",
                    textTransform: "uppercase",
                    color: "rgba(255,255,255,0.8)",
                    textShadow: "0 1px 4px rgba(0,0,0,0.3)",
                  }}
                >
                  {proj.type}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Mobile view - vertical list of projects */}
      <div
        className="mobile-projects-list"
        style={{
          display: "none",
          padding: "80px 20px 120px",
          overflowY: "auto",
          height: "100vh",
        }}
      >
        <style>{`
          @media (max-width: 768px) {
            .mobile-projects-list {
              display: block !important;
            }
          }
        `}</style>
        <h1
          style={{
            fontFamily: "'Garet', sans-serif",
            fontWeight: 700,
            fontSize: "2rem",
            color: "#0A0A0A",
            marginBottom: "24px",
          }}
        >
          Works
        </h1>
        <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
          {PROJECTS.map((proj) => (
            <div
              key={proj.id}
              onClick={() => navigate(`/project/${proj.slug}`)}
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                cursor: "pointer",
                boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
              }}
            >
              <div style={{ position: "relative", paddingTop: "75%" }}>
                {proj.video ? (
                  <video
                    src={proj.video}
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="metadata"
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: proj.objectPosition || "center",
                    }}
                  />
                ) : (
                  <img
                    src={proj.image}
                    alt={proj.title}
                    style={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: proj.objectPosition || "center",
                    }}
                  />
                )}
              </div>
              <div
                style={{
                  padding: "12px 16px",
                  background: "#FFFFFF",
                }}
              >
                <span
                  style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: "0.65rem",
                    fontWeight: 500,
                    color: "#8B8BF5",
                    textTransform: "uppercase",
                    letterSpacing: "0.1em",
                  }}
                >
                  {proj.type}
                </span>
                <h3
                  style={{
                    fontFamily: "'Garet', sans-serif",
                    fontWeight: 700,
                    fontSize: "1rem",
                    color: "#0A0A0A",
                    margin: "4px 0 0",
                  }}
                >
                  {proj.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Bottom gradient */}
      <div
        style={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "130px",
          background: "linear-gradient(to top, rgba(255,255,255,0.95) 0%, transparent 100%)",
          zIndex: 9,
          pointerEvents: "none",
        }}
      />
    </motion.div>
  );
}
